/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import { SetFromPlace } from './../../types';
import { getPlaceObject } from '../../utils/reverseGeoCode';
import queryString from 'query-string';
import AutoComplete from '../../components/CabModifySearch/CabAutoComplete';
import '../../components/CabModifySearch/CabModifySearch.css';
import { OUTSTATION_ONE_WAY, getShortCode } from '../../constants/tripTypes';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';
import { isWebView } from '../../utils/commonUtils';
const dayjs = require('dayjs');

type EPassSearchProp = {
  isMobileDevice: boolean;
  handleRequired: () => void;
  handleNotRequired: () => void;
  setListingUrl: React.Dispatch<React.SetStateAction<string>>;
  setCarPrice: React.Dispatch<React.SetStateAction<string>>;
  setCabsFound: React.Dispatch<React.SetStateAction<boolean>>;
};
const EPassSearch = ({
  isMobileDevice,
  handleRequired,
  handleNotRequired,
  setListingUrl,
  setCarPrice,
  setCabsFound
}: EPassSearchProp) => {
  const [widget, setWidget] = useState<null | number>(null);
  const [showFromDetails, setShowFromDetails] = useState(false);
  const [inputName, setInputName] = useState('tripType');
  const [showToDetails, setShowToDetails] = useState(false);
  const [activate, setActivate] = useState(null);
  const [fromCity, setFromCity] = useState('');
  const [fromStn, setFromStn] = useState('');
  const [fromPlaceId, setFromPlaceId] = useState<string | null>(null);
  const [fromPlaceObject, setFromPlaceObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null
  });
  const [toCity, setToCity] = useState('');

  const [toStn, setToStn] = useState('');
  const [toPlaceId, setToPlaceId] = useState<string | null>(null);
  const [toPlaceObject, setToPlaceObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null
  });

  const [pickUpFieldError, setPickUpFieldError] = useState(false);
  const [dropFieldError, setDropFieldError] = useState(false);
  const tomorrow = new Date();
  tomorrow.setDate(new Date().getDate() + 1);
  const date = dayjs(tomorrow).format('DD-MM-YYYY');
  const onFromChange = async (city: string, stn: string, placeId: string) => {
    trackEPassPageEvent('Cab_SEO_Epass_From_Click');
    setFromCity(city);
    setFromStn(stn);
    setFromPlaceId(placeId);
    setFromPlaceObject(await getPlaceObject(placeId));
    closePopup();
  };

  const onToChange = async (city: string, stn: string, placeId: string) => {
    trackEPassPageEvent('Cab_SEO_Epass_To_Click');
    setToCity(city);
    setToStn(stn);
    setToPlaceId(placeId);
    setToPlaceObject(await getPlaceObject(placeId));
    closePopup();
  };
  const closePopup = () => {
    setWidget(null);
    setActivate(null);
    setShowFromDetails(false);
    setShowToDetails(false);

    const body = document.getElementsByTagName('body');
    body[0].classList.remove('bodyFixed');
  };

  const handlePopup = (idx, cName, e) => {
    if (cName) {
      setWidget(idx);
      setInputName(cName);
    } else {
      setWidget(idx);
    }
    if (isMobileDevice) {
      const body = document.getElementsByTagName('body');
      body[0].classList.add('bodyFixed');
    }
  };
  const findLowestPriceFromCabList = (cabList = []): string => {
    const carPrices = cabList
      .filter(
        cab =>
          cab['cab_fare_detail'] &&
          cab['cab_fare_detail']['total_amount'] &&
          Number.isInteger(cab['cab_fare_detail']['total_amount'])
      )
      .map(cab => cab['cab_fare_detail']['total_amount']);

    return carPrices.length > 0 ? Math.min(...carPrices).toString() : '10/Km';
  };
  const transferToFunnel = async (omniUrlArgs = '') => {
    if (!fromPlaceId) {
      setPickUpFieldError(true);

      setTimeout(() => {
        setPickUpFieldError(false);
      }, 2000);
      return;
    }

    if (!toPlaceId) {
      setDropFieldError(true);

      setTimeout(() => {
        setDropFieldError(false);
      }, 2000);
      return;
    }

    const requestBody = {
      departure_date: date, //format(tomorrow, 'dd-mm-yyyy'),// 'dd-mm-yyyy'),
      return_date: null,
      trip_type: 'OW',
      pickup_time: '11:30',
      drop_time: null,
      source_location: {
        city: true,
        address: fromPlaceObject.address,
        latitude: fromPlaceObject.latitude,
        longitude: fromPlaceObject.longitude,
        pincode: '',
        place_id: fromPlaceObject.place_id,
        is_city: fromPlaceObject.is_city
      },
      destination_location: {
        city: true,
        address: toPlaceObject.address,
        latitude: toPlaceObject.latitude,
        longitude: toPlaceObject.longitude,
        pincode: '',
        place_id: toPlaceObject.place_id,
        is_city: toPlaceObject.is_city
      },
      source_city: null,
      destination_city: null,
      booking_device: 'desktop',
      package_key: null,
      airport_cabs_enabled: true,
      hr_cabs_enabled: true,
      book_mode: 'A',
      at_cross_sell_request: false,
      profile_type: 'PERSONAL',
      session_token: '',
      email: '',
      is_default_search: true,
      is_e_pass_enabled: true,
      is_custom_payment_allowed: true
    };

    const url = `https://cabs.makemytrip.com/desktop/searchV2`;
    const results = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    })
      .then(res => res.json())
      .catch(e => []);

    const urlObj = {
      fromCity: JSON.stringify(fromPlaceObject),
      toCity: JSON.stringify(toPlaceObject),
      tripType: getShortCode(OUTSTATION_ONE_WAY),
      departDate: date,
      pickupTime: '11:30'
    };
    const listingUrl = isWebView()
      ? ` mmyt://react/?page=cabsListing&deeplink=true&toPlaceId=${toPlaceId}&fromPlaceId=${fromPlaceId}&tripType=OW&startDate=${date}`
      : `https://cabs.makemytrip.com/cabsListing?${queryString.stringify(
          urlObj
        )}`;
    setListingUrl(listingUrl);
    const requiredOrNot = results.response //if no response, not required else based on r_pass_required
      ? results.response.e_pass_required
        ? handleRequired
        : handleNotRequired
      : handleNotRequired;
    requiredOrNot();
    if (results.response && results.response.cab_list) {
      setCarPrice(findLowestPriceFromCabList(results.response.cab_list));
      if (results.response.cab_list.length > 0) {
        setCabsFound(true);
      }
    }
    if (!results.response || !results.response.cab_list) {
      setCabsFound(false);
    }
    trackEPassPageEvent('Cab_SEO_Epass_Search_Click');
    // trackTemplateEvent('Cab_SEO_Search_Click');
    // window.location = Object(url);
  };
  const arr = [
    <React.Fragment>
      <AutoComplete
        autoFocus={true}
        travelFor={OUTSTATION_ONE_WAY}
        placeholder={'Enter PickUp address'}
        closeCityPopup={closePopup}
        onChange={onFromChange}
        widget={widget}
      />
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>,

    <React.Fragment>
      <AutoComplete
        autoFocus={true}
        widget={widget}
        travelFor={OUTSTATION_ONE_WAY}
        placeholder={'Enter Drop address'}
        closeCityPopup={closePopup}
        onChange={onToChange}
      />
      <div className="hsBackDrop" onClick={closePopup}></div>
    </React.Fragment>
  ];

  return (
    <section style={{ marginBottom: '0px' }} className="epass__top">
      <div className="epass__main epass__assit__wrap">
        <div className="epass__assistance dark__text">
          <p className="section__heading latoBlack">e-Pass Assistance</p>

          <p className="section__subheading">
            {!isMobileDevice ? (
              <span>
                Most states have released their own guidelines for e-Passes,
                which are required for entering your destination state. Book
                your cab with us in 3 simple steps
              </span>
            ) : (
              <span>Book your cab with us in 3 simple steps:</span>
            )}
          </p>

          <ul className="epass__usp latoBold blackText">
            <li>
              <span className="check_circle"></span>{' '}
              {`Check if you need an e-Pass
              on your route`}
            </li>
            <li>
              <span className="check_circle"></span>{' '}
              {`Book a cab with us & get
              cab details to apply for your e-Pass`}
            </li>
            <li>
              <span className="check_circle"></span>{' '}
              {`Share issued e-Pass with us to ensure hassle-free travel`}
            </li>
          </ul>
        </div>
        <div className="epass__form dark__text">
          <p className="epass__form__title latoBlack">
            Check e-Pass Requirement{' '}
            {!isMobileDevice && <span>on Your Route</span>}
          </p>
          <p className="epass__form__subtitle">
            Fill the names of your starting city and destination city to check
            for e-pass requirements.
          </p>
          <div
            style={{
              background: 'unset',
              padding: '0px'
            }}
            className="rsw"
          >
            <div
              style={{ padding: '0px' }}
              className={`form__field__wrap rsw_inputBox  ${
                widget !== null ? `inactiveWidget` : ``
              } ${widget === 0 ? `activeWidget` : ``}`}
            >
              <div className={`form__field ${''}`}>
                <label className="latoBold darkGreyText">{'From'}</label>
                <input
                  placeholder={'Select Starting City'}
                  type="text"
                  defaultValue={fromCity}
                  onFocus={event => handlePopup(0, 'fromCity', event)}
                />
              </div>
              <p
                className="dateErrorMsg whiteText"
                style={{
                  display: pickUpFieldError ? 'block' : 'none',
                  marginTop: '10px'
                }}
              >
                Please enter pickup location
              </p>
              {widget === 0 && arr[widget]}
            </div>
            <div
              style={{ width: '100%', paddingLeft: '0px', paddingRight: '0px' }}
              className={`form__field__wrap  rsw_inputBox ${
                widget !== null ? `inactiveWidget` : ``
              } ${widget === 0 ? `activeWidget` : ``}`}
            >
              <div className={`form__field ${''}`}>
                <label className="latoBold darkGreyText">{'To'}</label>
                <input
                  placeholder={'Select Destination City'}
                  type="text"
                  defaultValue={toCity}
                  onFocus={event => handlePopup(1, 'fromCity', event)}
                />
              </div>
              <p
                className="dateErrorMsg whiteText"
                style={{
                  display: dropFieldError ? 'block' : 'none',
                  marginTop: '10px'
                }}
              >
                Please enter drop location
              </p>

              {widget === 1 && arr[widget]}
            </div>
          </div>
          <button
            className="epass__form__btn pushBottom"
            onClick={() => {
              transferToFunnel();
            }}
          >
            {' '}
            Search
          </button>
        </div>
      </div>
    </section>
  );
};

export default EPassSearch;
